import React, { useState } from 'react'
import classes from 'classnames'

import { validateInput } from '../../utils'
import styles from './Input.module.scss'

interface InputPropsType {
  containerClass?: string,
  disabled: boolean,
  inputClass?: string,
  label?: string,
  name: string,
  onChange: (name: string, val: string | null) => void,
  required?: boolean,
  value: string,
}

const Input = (props: InputPropsType) => {
  const {
    containerClass = '',
    disabled = false,
    inputClass = '',
    label,
    name,
    onChange,
    required = false,
    value,
  } = props

  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const containerClassName = classes(styles.inputComponent, containerClass)
  const inputClassName = classes(
    styles.inputComponentInput, 
    { [styles.inputComponentError]: errorMessage },
    inputClass
  )

  const onChangeHandler = (e: any) => {
    if (e.target.value && e.target.value.trim) {
      let trimmedInputValue = e.target.value.trim()
      if (!trimmedInputValue.length) {
        return ''
      }
    }
    const validation = validateInput(e.target.name, e.target.value, value)
    if (validation.updatedVal === value) {
      return
    }
    setErrorMessage(validation.error)
    return onChange(e.target.name, validation.updatedVal)
  }

  return (
    <div className={containerClassName}>
      <input
        className={inputClassName}
        disabled={disabled}
        id={name}
        name={name}
        onChange={onChangeHandler}
        placeholder={label}
        type='text'
        value={value} />
      { (required && value === '') ? (
          <div className={styles.requiredAsterisk}>
            <span><span className={styles.invisibleText}>{label}</span>*</span>
          </div>
        ) : null 
      }
      { errorMessage ? (
          <div className={styles.errorBang}>
            <span>!</span>
          </div>
        ) : null
      }
      { errorMessage ? (
          <span className={styles.errorMessage}>{errorMessage}</span>
        ) : null
      }
    </div>
  )
}

export default Input;
